import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, isSuperAdmin } from "../../utils/auth";

export const ProtectedRoute: React.FC = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-default-99">
        <div className="bg-white border border-border-gray rounded p-8 max-w-sm text-center">
          <h2 className="text-lg font-bold text-gray-800 mb-2">Access Denied</h2>
          <p className="text-sm text-gray-500 mb-4">
            This panel is restricted to super administrators only.
          </p>
          <button
            className="text-sm text-link-blue underline"
            onClick={() => {
              localStorage.removeItem("adminAuthToken");
              localStorage.removeItem("adminRefreshToken");
              window.location.href = "/login";
            }}
          >
            Back to login
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
